/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/ArticleFooter/theme';

export const ArticleFooterTheme = theme;
